import React from "react";
import { Menu } from "@headlessui/react";
import {
  ArrowTopRightOnSquareIcon,
  CreditCardIcon,
  ShareIcon,
  QuestionMarkCircleIcon,
  ArrowRightOnRectangleIcon,
  ArrowUpRightIcon,
} from "@heroicons/react/24/outline";
import { cn } from "../../../utils/cn";

interface ToolbarMenuProps {
  user: any;
  isGuest: boolean;
  onViewProject: () => void;
  onManageSubscription: () => void;
  onShare: () => void;
  onSignOut: () => void;
  onLearnMore: () => void;
}

export const ToolbarMenu: React.FC<ToolbarMenuProps> = ({
  user,
  isGuest,
  onViewProject,
  onManageSubscription,
  onShare,
  onSignOut,
  onLearnMore,
}) => {
  const Divider = () => (
    <div className="flex justify-center py-2">
      <div
        className="w-[90%] h-px bg-gray-200"
        style={{
          backgroundColor: "#e5e7eb !important" as any,
          height: "1px !important" as any,
        }}
      />
    </div>
  );

  return (
    <div
      className="feedbackflow-toolbar-menu-wrapper"
      style={{
        colorScheme: "light",
        color: "#1f2937",
        fontSize: "14px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <Menu as="div" className="relative">
        <Menu.Button
          className="w-8 h-8 flex items-center justify-center text-black hover:text-gray-700 rounded-full hover:bg-gray-100"
          style={{
            color: "#1f2937 !important" as any,
            backgroundColor: "transparent !important" as any,
            border: "none !important" as any,
            background: "transparent",
          }}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            style={{
              color: "#1f2937 !important" as any,
              width: "20px !important" as any,
              height: "20px !important" as any,
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
            />
          </svg>
        </Menu.Button>

        <Menu.Items
          className="absolute right-0 bottom-full mb-2 w-72 rounded-lg bg-white shadow-lg py-3 border border-gray-200"
          style={{
            backgroundColor: "#ffffff !important" as any,
            color: "#1f2937 !important" as any,
            border: "1px solid #e5e7eb !important" as any,
            background: "#ffffff",
          }}
        >
          <div className="px-4 pb-3">
            <h3
              className="text-lg font-semibold text-gray-900"
              style={{
                color: "#111827 !important" as any,
                fontSize: "18px !important" as any,
                fontWeight: "600 !important" as any,
              }}
            >
              Add comments & recordings on this page.
            </h3>
            <button
              onClick={onLearnMore}
              className="mt-1 text-gray-600 hover:text-gray-900 inline-flex items-center text-sm"
              style={{
                color: "#6b7280 !important" as any,
                fontSize: "14px !important" as any,
                background: "none !important" as any,
                border: "none !important" as any,
              }}
            >
              Learn more
              <ArrowUpRightIcon
                className="w-4 h-4 ml-1"
                style={{
                  color: "#6b7280 !important" as any,
                  width: "16px !important" as any,
                  height: "16px !important" as any,
                }}
              />
            </button>
          </div>

          <Divider />

          <div className="px-2 py-2">
            {user && (
              <>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={onViewProject}
                      className={cn(
                        "w-full text-left px-3 py-2 text-sm flex items-center rounded-md",
                        active ? "bg-gray-50" : ""
                      )}
                      style={
                        {
                          color: "#1f2937 !important" as any,
                          fontSize: "14px !important" as any,
                          backgroundColor: active
                            ? "#f9fafb !important"
                            : "transparent !important",
                          border: "none !important" as any,
                          background: active ? "#f9fafb" : "transparent",
                        } as any
                      }
                    >
                      <ArrowTopRightOnSquareIcon
                        className="w-5 h-5 mr-3"
                        style={{
                          color: "#1f2937 !important" as any,
                          width: "20px !important" as any,
                          height: "20px !important" as any,
                        }}
                      />
                      View Project
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={onManageSubscription}
                      className={cn(
                        "w-full text-left px-3 py-2 text-sm flex items-center rounded-md",
                        active ? "bg-gray-50" : ""
                      )}
                      style={
                        {
                          color: "#1f2937 !important" as any,
                          fontSize: "14px !important" as any,
                          backgroundColor: active
                            ? "#f9fafb !important"
                            : "transparent !important",
                          border: "none !important" as any,
                          background: active ? "#f9fafb" : "transparent",
                        } as any
                      }
                    >
                      <CreditCardIcon
                        className="w-5 h-5 mr-3"
                        style={{
                          color: "#1f2937 !important" as any,
                          width: "20px !important" as any,
                          height: "20px !important" as any,
                        }}
                      />
                      Manage Subscription
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={onShare}
                      className={cn(
                        "w-full text-left px-3 py-2 text-sm flex items-center rounded-md",
                        active ? "bg-gray-50" : ""
                      )}
                      style={
                        {
                          color: "#1f2937 !important" as any,
                          fontSize: "14px !important" as any,
                          backgroundColor: active
                            ? "#f9fafb !important"
                            : "transparent !important",
                          border: "none !important" as any,
                          background: active ? "#f9fafb" : "transparent",
                        } as any
                      }
                    >
                      <ShareIcon
                        className="w-5 h-5 mr-3"
                        style={{
                          color: "#1f2937 !important" as any,
                          width: "20px !important" as any,
                          height: "20px !important" as any,
                        }}
                      />
                      Share Link
                    </button>
                  )}
                </Menu.Item>
              </>
            )}
          </div>

          <Divider />

          <div className="px-2">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onLearnMore}
                  className={cn(
                    "w-full text-left px-3 py-2 text-sm flex items-center rounded-md",
                    active ? "bg-gray-50" : ""
                  )}
                  style={
                    {
                      color: "#1f2937 !important" as any,
                      fontSize: "14px !important" as any,
                      backgroundColor: active
                        ? "#f9fafb !important"
                        : "transparent !important",
                      border: "none !important" as any,
                      background: active ? "#f9fafb" : "transparent",
                    } as any
                  }
                >
                  <QuestionMarkCircleIcon
                    className="w-5 h-5 mr-3"
                    style={{
                      color: "#1f2937 !important" as any,
                      width: "20px !important" as any,
                      height: "20px !important" as any,
                    }}
                  />
                  Support
                </button>
              )}
            </Menu.Item>
            {(user || isGuest) && (
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={onSignOut}
                    className={cn(
                      "w-full text-left px-3 py-2 text-sm flex items-center rounded-md text-red-600",
                      active ? "bg-red-50" : ""
                    )}
                    style={
                      {
                        color: "#dc2626 !important" as any,
                        fontSize: "14px !important" as any,
                        backgroundColor: active
                          ? "#fef2f2 !important"
                          : "transparent !important",
                        border: "none !important" as any,
                        background: active ? "#fef2f2" : "transparent",
                      } as any
                    }
                  >
                    <ArrowRightOnRectangleIcon
                      className="w-5 h-5 mr-3"
                      style={{
                        color: "#dc2626 !important" as any,
                        width: "20px !important" as any,
                        height: "20px !important" as any,
                      }}
                    />
                    Sign out
                  </button>
                )}
              </Menu.Item>
            )}
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
};
